import { DropdownSortOption, DefaultSortOptionValues } from './types';

export const DEFAULT_SORT_OPTIONS: DropdownSortOption<DefaultSortOptionValues>[] = [
    {
        label: 'По умолчанию',
        value: null,
    },
    {
        label: 'Сначала новые',
        value: DefaultSortOptionValues.New,
    },
    {
        label: 'Сначала старые',
        value: DefaultSortOptionValues.Old,
    },
];
